import styled from "styled-components";

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 91px;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: 16px;
  resize: none;
  border: solid 1px transparent;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #1e1e1e;

  &::placeholder {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;
    color: #aaaaaa;
  }

  &:not(:read-only) {
    &:focus {
      border: solid 1px #00c7c7;
      background-color: #ffffff;
    }
  }

  &:read-only {
    color: #808080;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
